module.exports = __webpack_public_path__ + "static/media/DMSans-Medium.fbbc5a51.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DMSans-Medium.ttf
// module id = 146
// module chunks = 0